import React from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import PropTypes from "prop-types";

const MsisdnTextBox = ({
  name,
  label = "Número de Telefono *",
  defaultValue,
  changeHandler,
}) => {
  return (
    <>
      <FloatingLabel label={label} className="mb-3">
        <Form.Control
          type="text"
          name={name}
          id={name}
          maxLength="10"
          onkeypress="return event.charCode>=48 && event.charCode<=57"
          value={defaultValue}
          required
          pattern="^\d{10}$"
          onChange={(event) => {
            event.target.value = event.target.value.replace(/[^\d]+/g, "");
            changeHandler(event);
          }}
          placeholder="Ingrese el Telefono"
        />
      </FloatingLabel>
    </>
  );
};
MsisdnTextBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  changeHandler: PropTypes.func,
};
export default MsisdnTextBox;
